import { Component } from "react";
import { Table } from "react-bootstrap";
import * as React from "react";

interface ITopFoundationsState {
  data: any[]
}

interface ITopFoundationsProps {
  displayClickHere?: boolean
}

export class TopFoundations extends Component<ITopFoundationsProps, ITopFoundationsState> {
  state: ITopFoundationsState = {
    data: []
  }

  componentDidMount() {
    this.loadFoundationMark50()
  }

  loadFoundationMark50() {
    const assetLevelRequest = { method: 'POST', body: JSON.stringify({ action: 'foundationmark50', state: '', assetLevel: 0, monthNumber: 12 }) }
    fetch('https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/foundationmark50', assetLevelRequest)
      .then((resp) => resp.json())
      .then((json) => {
        // tslint:disable-next-line:no-console
        this.setState({ data: json })
      })
  }

  renderStars(numberOfStars: number, key: string) {
    const html = []
    for (let i = 0; i < numberOfStars; i++) {
      html.push(<i className="fa fa-star" aria-hidden="true" key={`star-${key}-${i}`} />)
    }
    return html
  }

  renderCurrency(totalAssets: number) {
    return <span>{totalAssets.toLocaleString()}</span>
  }

  static renderLoadingScreen(noData) {
    let loadingHtml = null
    if (noData) {
      loadingHtml = <i className="fa fa-cog fa-spin"></i>
    }
    return (
      loadingHtml
    )
  }

  render() {
    const { data } = this.state
    const { displayClickHere } = this.props
    let rowCount = 0

    const title = displayClickHere ? <b><span>Click <a style={{ color: '#333' }} href="#/foundationmark15">here</a> for more interactive visualizations</span></b> : ''

    return (
      <section>
        <header style={{ fontSize: '1.6rem', color: '#00B050', textAlign: 'center' }}>{title}</header>
        <Table striped bordered>
          <thead>
            <tr style={{ textAlign: 'center', fontSize: '0.9em' }}>
              <th style={{ textAlign: 'center', maxWidth: '50px' }}>Total Assets</th>
              <th>Foundation Name</th>
              <th>Location</th>
              <th style={{ textAlign: 'center', maxWidth: '75px' }}>Year Ending&nbsp;<a href="#/faq?id=aboutIndices" title="Learn More"><i className="fa fa-question-circle" style={{ color: 'rgb(45, 92, 160)' }}></i></a></th>
              <th style={{ textAlign: 'center' }}> 1 Yr Rating&nbsp;<a href="#/?tab=3" title="Learn More"><i className="fa fa-question-circle" style={{ color: 'rgb(45, 92, 160)' }}></i></a></th>
              <th style={{ textAlign: 'center' }}> 3 Yr Rating</th>
              <th style={{ textAlign: 'center' }}> 5 Yr Rating</th>
            </tr>
          </thead>
          <tbody>
            {data.map((row) => {
              rowCount++
              let currency = ''
              if (rowCount === 1) {
                currency = '$'
              }
              const href = '#/foundationmark15details?ein=' + row.ein
              return (
                <tr key={row.ein} style={{ textAlign: 'center !important' }}>
                  <td className="cell50" style={{ textAlign: 'right', fontSize: '0.9em' }}>{currency}{(parseFloat(row.totalAssets.toFixed(0))).toLocaleString()}</td>
                  <td className="cell50" style={{ textAlign: 'left', fontSize: '0.9em' }}><a title={row.name} href={href}>{row.name.substring(0, 20) + '...'}</a></td>
                  <td className="cell50" style={{}}>{row.location}</td>
                  <td className="cell50" style={{ textAlign: 'center', fontSize: '0.9em' }}>{row.yearEnding}</td>
                  <td className="cell50" style={{ textAlign: 'center', fontSize: '0.9em' }}>{this.renderStars(row.oneYearStar, 'one-year')}</td>
                  <td className="cell50" style={{ textAlign: 'center', fontSize: '0.9em' }}>{this.renderStars(row.threeYearStar, 'three-year')}</td>
                  <td className="cell50" style={{ textAlign: 'center', fontSize: '0.9em' }}>{this.renderStars(row.fiveYearStar, 'five-year')}</td>
                </tr>
              )
            })}
          </tbody>
        </Table>
      </section>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/components/visualizations/TopFoundations/index.tsx